module.exports = __webpack_public_path__ + "img/mobile/IntroPopups/confirm_button@2x.png?1.0.17";